import { mapValues } from 'lodash';
/**
 * Version 27 migrations: Add registration settings configs for air request
 */
export default function v27(website) {
  return {
    ...website,
    eventVersion: 27,
    layoutItems: mapValues(website.layoutItems, layoutItem => {
      if (layoutItem.widgetType === 'AirRequest') {
        return {
          ...layoutItem,
          config: {
            ...layoutItem.config,
            registrationSettings: {
              requireAirRequest: false,
              allowBookOwnFlights: true,
              ownReservationText: 'EventWidgets_AirRequest_OwnReservation__resx',
              maxNumberOfAirRequestsPerAttendee: 1,
              allowModification: true,
              allowNewRequestUntil: '',
              allowAirModificationUntil: ''
            }
          }
        };
      }
      return layoutItem;
    })
  };
}
